import type { Root } from '@/model/Root';

import { PersonsList } from '@/components/person/PersonsList';
import { RootsList, type RootsListProps } from '@/components/root/RootsList';
import type { Person } from '@/model/Person';
import type { WebAPIError } from '@/store/api/WebApiResponse';
import type { SerializedError } from '@reduxjs/toolkit';
import { ResultsWrap } from './ResultsWrap';

export type TabId = 'roots' | 'persons';

type Props = {
  displayMode: RootsListProps['displayMode'];
  roots: Root[];
  persons: Person[];
  rootsAreLoading: boolean;
  personsAreLoading: boolean;
  rootsLoadingError?: WebAPIError | SerializedError;
  personsLoadingError?: WebAPIError | SerializedError;
  emphasizedText?: string;
  activeTab: TabId;
};

export const ResultsPanel = ({
  displayMode,
  roots,
  persons,
  rootsAreLoading,
  personsAreLoading,
  rootsLoadingError,
  personsLoadingError,
  emphasizedText,
  activeTab,
}: Props) => {
  const rootsStatus = rootsAreLoading
    ? 'loading'
    : rootsLoadingError
      ? { error: rootsLoadingError }
      : 'success';
  const personsStatus = personsAreLoading
    ? 'loading'
    : personsLoadingError
      ? { error: personsLoadingError }
      : 'success';

  return (
    <>
      {activeTab === 'roots' && (
        <ResultsWrap status={rootsStatus}>
          <RootsList displayMode={displayMode} roots={roots} emphasizedText={emphasizedText} />
        </ResultsWrap>
      )}

      {activeTab === 'persons' && (
        <ResultsWrap status={personsStatus}>
          <PersonsList
            displayMode={displayMode}
            persons={persons}
            emphasizedText={emphasizedText}
          />
        </ResultsWrap>
      )}
    </>
  );
};
